import React, { Component } from "react"
import * as styles from "./submissionBountyContest.module.scss"
import Popup from "reactjs-popup"
import "../../../static.css"

class SubmissionBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
  }

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }

  showSubmission() {
    let submissionBtnClass =
      this.props.submissionText && this.props.selectedFile
        ? "form-control btn btn-submission-active"
        : "form-control btn btn-submission"

    if (this.props.answerSubmitted === false) {
      return (
        <React.Fragment>
          <div className={styles.content}>
            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.inputuserwrapper}>
                    <textarea
                      required="required"
                      id="description"
                      rows="6"
                      className={styles.formcontrol}
                      placeholder="Enter 1 - 128 bytes hex value (e.g. 486c6f23ef....)"
                      onChange={this.props.handleEnableSubmissionButton}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.inputuserwrapper}>
                    <input
                      type="file"
                      id="uploadfile"
                      onChange={this.props.onChangeUploadFileHandler}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <br />
                  <span className={styles.submitWarning}>
                    Please enter what you believe is the original data of the
                    encrypted ciphertext in the above text box, plus a paper in
                    PDF format (&lt;=500KB) describing in details about how you
                    work out the original data. To avoid abusive behavior, any
                    attempt within 60 minutes of your last submission will be
                    rejected.
                  </span>
                </div>
              </div>
            </div>
            {this.props.errorSubmission ? (
              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <span className={styles.errorMsg}>
                      {" "}
                      Error: {this.props.errorSubmission}{" "}
                    </span>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          <div className={styles.actions}>
            <button
              className={submissionBtnClass}
              disabled={
                this.props.submissionText && this.props.selectedFile
                  ? null
                  : "disabled"
              }
              onClick={() => {
                this.props.closeModalWithSubmission()
              }}
            >
              Submit
            </button>
          </div>
        </React.Fragment>
      )
    }

    // result
    if (this.props.answerSubmitted === true) {
      return (
        <React.Fragment>
          <div className={styles.content}>
            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <div>Thank you for your submission. </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div>
                  <p>
                    Your answer:
                    <br />
                    {this.props.submissionText}
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div>
                  <p>
                    Your paper: <br />
                    {this.props.selectedFile.name}
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <label> Submission Count: {this.props.submissionTotal} </label>
              </div>

              <div className="offset-md-1 col-md-5">
                {this.props.resultMatched === "y" ? (
                  <label> Result: Correct</label>
                ) : (
                  <label style={{ color: "red" }}> Result: Wrong</label>
                )}
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <button
              className="form-control btn btn-submission-active"
              onClick={() => {
                this.props.closeModal()
              }}
            >
              OK
            </button>
          </div>
        </React.Fragment>
      )
    }
  }

  en() {
    return (
      <Popup
        className="submission"
        open={this.props.open}
        closeOnDocumentClick
        onClose={this.props.closeModal}
      >
        {close => (
          <div className={styles.modal}>
            <a className={styles.close} onClick={this.props.closeModal}>
              &times;
            </a>

            {this.showSubmission()}
          </div>
        )}
      </Popup>
    )
  }

  showSubmissionCT() {
    let submissionBtnClass =
      this.props.submissionText && this.props.selectedFile
        ? "form-control btn btn-submission-active"
        : "form-control btn btn-submission"

    if (this.props.answerSubmitted === false) {
      return (
        <React.Fragment>
          <div className={styles.content}>
            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.inputuserwrapper}>
                    <textarea
                      required="required"
                      id="description"
                      rows="6"
                      className={styles.formcontrol}
                      placeholder="輸入1到128個16進制值的字節 (例如: 486c6f23ef...)"
                      onChange={this.props.handleEnableSubmissionButton}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.inputuserwrapper}>
                    <input
                      type="file"
                      id="uploadfile"
                      onChange={this.props.onChangeUploadFileHandler}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <br />
                  <span className={styles.submitWarning}>
                    請於以上文本框中輸入您認為是加密密文的原數據，另加
                    PDF（&lt;=500KB）格式的可以詳細說明破解方法的完整文
                    章。為避免濫用行為，您必須於最後一次提交答案的60分
                    鐘後方可再次提交答案。
                  </span>
                </div>
              </div>
            </div>
            {this.props.errorSubmission ? (
              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <span className={styles.errorMsg}>
                      {" "}
                      錯誤：{this.props.errorSubmission}{" "}
                    </span>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          <div className={styles.actions}>
            <button
              className={submissionBtnClass}
              disabled={
                this.props.submissionText && this.props.selectedFile
                  ? null
                  : "disabled"
              }
              onClick={() => {
                this.props.closeModalWithSubmission()
              }}
            >
              提交
            </button>
          </div>
        </React.Fragment>
      )
    }

    // result
    if (this.props.answerSubmitted === true) {
      return (
        <React.Fragment>
          <div className={styles.content}>
            <div className={styles.gap}>
              <div className="row">
                <div className="col-md-12">
                  <div>感謝您的提交。結果將通過電子郵件發送給您。 </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div>
                  <p>
                    您所提交的答案:
                    <br />
                    {this.props.submissionText}
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div>
                  <p>
                    您所提交的破解方法完整文章： <br />
                    {this.props.selectedFile.name}
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-5">
                <label> 提交次数： {this.props.submissionTotal} </label>
              </div>

              <div className="offset-md-1 col-md-6">
                {this.props.resultMatched === "y" ? (
                  <label> 結果：破解成功。</label>
                ) : (
                  <label style={{ color: "red" }}>
                    {" "}
                    結果：破解失敗。歡迎重試。
                  </label>
                )}
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <button
              className="form-control btn btn-submission-active"
              onClick={() => {
                this.props.closeModal()
              }}
            >
              確定
            </button>
          </div>
        </React.Fragment>
      )
    }
  }

  ct() {
    return (
      <Popup
        className="submission"
        open={this.props.open}
        closeOnDocumentClick
        onClose={this.props.closeModal}
      >
        {close => (
          <div className={styles.modal}>
            <a className={styles.close} onClick={this.props.closeModal}>
              &times;
            </a>

            {this.showSubmissionCT()}
          </div>
        )}
      </Popup>
    )
  }
}

export default SubmissionBountyContest
